import type { CropCycle } from '../../api/crop.api';

export type AssignedCrop =
  | { status: 'ok'; cropId: string; moduleId?: string }
  | { status: 'unassigned' }
  | { status: 'needs-zone' };

/** Etiqueta por defecto del ciclo (idéntica al backend): YYYY-A (ene-jun) / YYYY-B (jul-dic). */
export function defaultCycleLabel(date: string): string {
  const [year, month] = date.split('-');
  return `${year}-${Number(month) <= 6 ? 'A' : 'B'}`;
}

/** Cultivo del ciclo `ciclo` en la zona elegida (o en el lote si no tiene zonas). */
export function resolveCycleCrop(
  cycles: CropCycle[],
  lote: { loteId: string } | undefined,
  modules: { moduleId: string }[],
  moduleId: string,
  ciclo: string,
): AssignedCrop {
  let targetId: string | undefined;
  if (modules.length === 0) targetId = lote?.loteId;
  else if (modules.some(m => m.moduleId === moduleId)) targetId = moduleId;
  else return { status: 'needs-zone' };
  const c = cycles.find(x => x.targetId === targetId && x.ciclo === ciclo && !!x.cropId);
  if (!c) return { status: 'unassigned' };
  return modules.length === 0 ? { status: 'ok', cropId: c.cropId } : { status: 'ok', cropId: c.cropId, moduleId: targetId };
}
